import { z } from 'zod';
export const FACILITY_REQUEST_STATUSES = ['draft', 'submitted', 'approved', 'rejected', 'expired'];
export const facilityRequestBodySchema = z.object({
    name: z.string().trim().min(2).max(160),
    facilityType: z.enum(['hospital', 'lab', 'pharmacy']).default('hospital'),
    environment: z.enum(['live', 'demo']).default('live'),
    contactName: z.string().trim().max(120).nullable().optional(),
    contactEmail: z.string().trim().email().max(254).nullable().optional(),
    contactPhone: z.string().trim().max(30).nullable().optional(),
    planIds: z.array(z.string().uuid()).max(4).default([]),
    addOns: z.array(z.enum(['nphies', 'wasfaty'])).max(2).default([]),
    offlineEnabled: z.boolean().default(false),
    template: z.string().trim().max(60).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
    details: z.record(z.unknown()).default({}),
});
export const FACILITY_REQUEST_DRAFT_DAYS = 30;
//# sourceMappingURL=provision-templates.js.map